module.exports = __webpack_public_path__ + "static/img/8.a643820.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/8.png
// module id = gqvA
// module chunks = 0